import { useQuery } from "@tanstack/react-query";
import { callWithAuth } from "@/api/Api";
import { getCompletedLessons } from "@/api/Api";

export const useCompletedLessons = () => {
  const completedLessonsQuery = useQuery({
    queryKey: ["completedLessons"],
    queryFn: () => {
      return callWithAuth(getCompletedLessons);
    },
  });

  return {
    completedLessons: completedLessonsQuery.data?.lessons,
    isLoading: completedLessonsQuery.isLoading,
    isError: completedLessonsQuery.isError,
  };
}; 